"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.prepareOnlyHeaderLayoutProps = void 0;
var _auth = require("@ori/auth");
var _mapAndValidateBaseUrls = require("../../utils/mapAndValidateBaseUrls");
var _DefaultLayoutFeature = require("../default/DefaultLayoutFeature");
var _internal = require("./internal");
const prepareOnlyHeaderLayoutProps = ({
  page: {
    appLoaders,
    cultureSettings,
    language,
    features,
    developmentInfo,
    environment,
    servicesUrls,
    token,
    tenant,
    pageMetaData,
    requiredServicesUrls = [],
    periodCode,
    useLegacyKendoCulture = false,
    useLegacyTokenService = false,
    enableWebVitalsCollection = false,
    enableFavorites = false,
    operationId
  },
  layout: {
    languages,
    translations,
    defaultTranslations,
    componentsProps
  }
}) => ({
  page: {
    ...(appLoaders && {
      appLoaders
    }),
    ...(pageMetaData && {
      pageMetaData
    }),
    ...(translations && {
      translations
    }),
    ...(defaultTranslations && {
      defaultTranslations
    }),
    cultureSettings,
    language,
    customerId: _auth.NOT_LOGGED_IN_USER_ID,
    developmentInfo,
    environment,
    features: [...features.values()],
    isProduction: process.env.NODE_ENV === 'production',
    pageBuiltAt: new Date().toString(),
    pageFeatures: _DefaultLayoutFeature.DefaultLayoutFeature,
    periodCode,
    servicesUrls: (0, _mapAndValidateBaseUrls.mapAndValidateBaseUrls)(servicesUrls, [..._internal.onlyHeaderLayoutRequiredServices, ...requiredServicesUrls]),
    tenant,
    token,
    useLegacyKendoCulture,
    useLegacyTokenService,
    enableWebVitalsCollection,
    enableFavorites,
    operationId
  },
  layout: {
    ...(languages && {
      languages
    }),
    ...(componentsProps && {
      componentsProps
    })
  }
});
exports.prepareOnlyHeaderLayoutProps = prepareOnlyHeaderLayoutProps;
